import { Cat } from '../../../gameplay/registry';
import { FX_ONE } from '../fixed';
import { Order, UState, type World } from '../world';
import { setDestination } from './movement';

/** High-level order upkeep: patrol loops, guard/follow, attack-move arrival. */
export function updateBehaviour(w: World): void {
  const n = w.highSlot;
  for (let s = 0; s < n; s++) {
    if (!w.alive[s] || w.cat[s] !== Cat.Unit) continue;
    const ord = w.order[s];
    if (ord === Order.Patrol || ord === Order.AttackMove) {
      if (w.resolve(w.target[s]) >= 0) continue; // engaged
      if (w.moving[s]) continue;
      const dx = w.goalX[s] - w.x[s];
      const dy = w.goalY[s] - w.y[s];
      const near = dx * dx + dy * dy < FX_ONE * FX_ONE * 2;
      if (ord === Order.AttackMove) {
        if (near) {
          w.order[s] = Order.None;
          w.state[s] = UState.Idle;
        } else {
          w.state[s] = UState.Walking;
          setDestination(w, s, w.goalX[s], w.goalY[s]);
        }
      } else {
        if (near) {
          const hx = w.homeX[s];
          const hy = w.homeY[s];
          w.homeX[s] = w.goalX[s];
          w.homeY[s] = w.goalY[s];
          w.goalX[s] = hx;
          w.goalY[s] = hy;
        }
        w.state[s] = UState.Walking;
        setDestination(w, s, w.goalX[s], w.goalY[s]);
      }
    } else if (ord === Order.Guard || ord === Order.Follow) {
      const a = w.resolve(w.ally[s]);
      if (a < 0) {
        w.order[s] = Order.None;
        w.state[s] = UState.Idle;
        continue;
      }
      if (ord === Order.Guard && w.resolve(w.target[s]) >= 0) continue; // fighting near ward
      if (w.timer[s] > 0) {
        w.timer[s]--;
        continue;
      }
      w.timer[s] = 10;
      const dx = w.x[a] - w.x[s];
      const dy = w.y[a] - w.y[s];
      const keep = (ord === Order.Guard ? 2 : 1) * FX_ONE + w.extent(a);
      if (dx * dx + dy * dy > keep * keep) {
        w.state[s] = UState.Walking;
        setDestination(w, s, w.x[a], w.y[a]);
      } else if (w.cat[a] === Cat.Unit && !w.moving[a]) {
        w.moving[s] = 0;
        w.paths[s] = null;
        w.state[s] = UState.Idle;
      }
      if (ord === Order.Guard) {
        // Respond to attackers hitting the ward.
        if (w.tick - w.lastHurtTick[a] < 20) {
          w.goalX[s] = w.x[a];
          w.goalY[s] = w.y[a];
        }
      }
    } else if (ord === Order.None && w.state[s] !== UState.Idle && !w.moving[s]) {
      w.state[s] = UState.Idle;
    }
  }
}
